<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.7533 2.17969C11.3504 0.773437 9.48214 0 7.49665 0C3.39844 0 0.0636161 3.33482 0.0636161 7.43304C0.0636161 8.74219 0.405134 10.0212 1.05469 11.1496L0 15L3.94085 13.9654C5.02567 14.558 6.24777 14.8694 7.4933 14.8694H7.49665C11.5915 14.8694 15 11.5346 15 7.43638C15 5.45089 14.1562 3.58594 12.7533 2.17969ZM7.49665 13.6172C6.38504 13.6172 5.29687 13.3192 4.34933 12.7567L4.125 12.6228L1.78795 13.2355L2.41071 10.9554L2.26339 10.721C1.64397 9.73661 1.3192 8.60156 1.3192 7.43304C1.3192 4.0279 4.09152 1.25558 7.5 1.25558C9.15067 1.25558 10.7009 1.89844 11.8661 3.06696C13.0312 4.23549 13.7478 5.78571 13.7444 7.43638C13.7444 10.8449 10.9018 13.6172 7.49665 13.6172ZM10.885 8.98995C10.7009 8.8962 9.78683 8.44754 9.61607 8.38728C9.44531 8.32366 9.32143 8.29353 9.19755 8.48103C9.07366 8.66853 8.71875 9.0837 8.60826 9.21094C8.50112 9.33482 8.39062 9.35156 8.20647 9.25781C7.11496 8.71205 6.39844 8.28348 5.67857 7.04799C5.48772 6.71987 5.86942 6.7433 6.22433 6.03348C6.2846 5.9096 6.25446 5.80245 6.20759 5.7087C6.16071 5.61495 5.78906 4.70089 5.63504 4.32924C5.48438 3.96763 5.33036 4.01786 5.21652 4.01116C5.10938 4.00446 4.98549 4.00446 4.86161 4.00446C4.73772 4.00446 4.53683 4.05134 4.36607 4.23549C4.19531 4.42299 3.71652 4.87165 3.71652 5.78571C3.71652 6.69978 4.38281 7.58371 4.47321 7.70759C4.56696 7.83147 5.78237 9.70647 7.64732 10.5134C8.82589 11.0223 9.28795 11.0658 9.87723 10.9788C10.2355 10.9252 10.9754 10.5301 11.1295 10.0949C11.2835 9.6596 11.2835 9.28795 11.2366 9.21094C11.1931 9.12723 11.0692 9.08036 10.885 8.98995Z" :fill="fill"/>
    </svg>
</template>
<script>
export default {
    name: 'ui-whatsapp-icon',
    props: {
        fill: {
            type: String,
            default: '#5AC387'
        },
        design: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 15
        },
        height: {
            type: [String, Number],
            default: 15
        }
    }
}
</script>